const initialState =  false;

const sumdebitSearchReducer = (state = initialState, action) => {
    switch (action.type) {
        
        default: return state;
    }
}

export default sumdebitSearchReducer;